/**
 * @vuepress
 * ---
 * title: Advance
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * ---
 */
import Transformer from "@/transformers/transformer";
import moment from "moment";

/**
 * @class advanceTransformer
 */
class advanceTransformer extends Transformer {
  /**
   * Transform file to send
   * @param advance to send advance
   * @returns {Object} The transformed advance
   */

  static fetch({
    status,
    expected_delivery_date,
    folio,
    is_active,
    percentage,
    provider = {},
    advances,
    resident,
    total,
    totaladvances,
    related_sinisters: sinisters,
    id,
    advance_request: advanceRequest,
    iwarehouse,
    provider_types: providerTypes
  }) {
    const providerAccount = provider.provider_account[0]
      ? provider.provider_account[0]
      : {};
    return {
      advances: advances.map(
        ({
          percentage,
          user_requesting,
          amount,
          date,
          PDF,
          XML,
          comment,
          id,
          approval_status: approvalStatus,
          advance_type: advanceType,
          settlement_date: settlementDate
        }) => {
          return {
            percentage,
            userRequesting: user_requesting,
            amount: parseFloat(amount),
            date: moment(date).locale("es").format("DD/MM/YYYY"),
            pdf: PDF,
            xml: XML,
            comment,
            id,
            approvalStatus,
            advanceType,
            settlementDate: settlementDate ? moment(settlementDate).locale("es").format() : null
          };
        }
      ),
      status,
      date: moment(expected_delivery_date).locale("es").format("DD/MM/YYYY"),
      folio,
      id,
      isActive: is_active,
      percentage,
      provider: provider.provider_number,
      providerName: provider.name,
      providerBankAccount: providerAccount.account_number,
      providerClabe: providerAccount.clabe,
      providerBankName: providerAccount.bank && providerAccount.bank.short_name,
      providerCommercialName: `${provider.commercial_name} (${provider.provider_number})`,
      user: resident ? resident.user.receive_name : "",
      providerTypes,
      seeMoreProviderTypes: false,
      sinisters: sinisters.map(
        ({
          folio,
          sinister_number: sinisterNumber,
          requisition_number: requisitionNumber,
          sinister_roads: id, job_type: jobType
        }) => {
          return {
            id,
            folio,
            sinisterNumber,
            requisitionNumber,
            jobType
          };
        }
      ),
      showSinisters: false,
      total: total.total,
      totalAdvances: totaladvances,
      totalRemaining: +total.total - totaladvances,
      advanceRequest,
      iwarehouse,
    };
  }
  /**
   * Transform file to send
   *
   * @param advance to send advance
   *
   * @returns {Object} The transformed advance
   */

  static send(advance) {
    const formData = new FormData();
    formData.append("amount", advance.amount);
    if (advance.pdf) {
      formData.append("PDF", advance.pdf);
    }
    if (advance.xml) {
      formData.append("XML", advance.xml);
    }
    formData.append("comment", advance.comment);
    formData.append("advance_type", advance.advance_type);
    return formData;
  }
  /**
   * Transform file to send
   * @param advance to send advance
   * @returns {Object} The transformed advance
   */

  static update(advance) {
    const formData = new FormData();
    if (advance.pdf) {
      formData.append("PDF", advance.pdf);
    }
    if (advance.xml) {
      formData.append("XML", advance.xml);
    }
    return formData;
  }
}

export default advanceTransformer;



// WEBPACK FOOTER //
// ./src/transformers/purchase/advance.js